export const DIMENSIONS_GRANULARITIES = [
    'activityType',
    'chainType',
    'stores',
    'storeType',
    'region',
    'productHierarchy',
    'brandType',
    'ean',
    'localSupplier',
    'subSupplier',
    'brand',
    'holding',
    'assortmentTypology',
    'productTypology',
    'banner',
    'businessBrand',
    'dateGranularity'
];
export const INDICATORS_GRANULARITIES = [
    'sales',
    'quantity',
    'promotion',
    'averageWeeklySales',
    'averagePrice',
    'numericalDistribution',
    'weightedDistribution',
    'grossServiceRate',
    'netServiceRate',
    'nielsenMarketShare',
    'carrefourMarketShare',
    'benchmarkTrend',
    'warehouseStock',
    'storeStock',
    'salesPossessionRate',
    'businessEquationAllCustomers',
    'businessEquationCardholdersNonCardholders',
    'possessionZoomPage',
    'possessionZoomPageWithTheoretical',
    'nonPossessed',
    'competitorVision',
    'competitorVisionPromo',
    'dynamicClientZoomPage',
    'customerSegmentation'
];
export const KPI_GRANULARITIES = [...DIMENSIONS_GRANULARITIES, ...INDICATORS_GRANULARITIES, 'likeForLike'];
//# sourceMappingURL=granularities.constant.js.map